/* eslint-disable max-classes-per-file */
import { Location, MemoryHistory } from 'history';
import React from 'react';
import { MatchedRoute } from 'react-router-config';
import { Store } from 'redux';
import { i18n as I18NextInstance } from 'i18next';
import { MatchProps } from 'components/EpisodeEditorPublish/types';
import { createI18N } from './createI18N';
import { LocaleProvider, I18NProvider } from './context';

type FetchDataProps = {
  history: MemoryHistory;
  match: MatchProps;
  location: Location;
  store: Store<any>;
  baseUrl: string;
  route: MatchedRoute<{
    [x: string]: string;
  }>;
};

type WithI18NProps = {
  locale?: string;
  i18n?: I18NextInstance;
  BaseComponent: React.ComponentType & {
    fetchData?: (data: FetchDataProps) => void;
  };
};

// This is the HoC used to provide the server with the contexts needed
// for i18n to happen before the HTML is sent to the client.
export const withI18N = ({
  locale = 'en',
  i18n = createI18N(),
  BaseComponent,
}: WithI18NProps) => {
  const WithI18NComponent = (props: any) => {
    return (
      <LocaleProvider locale={locale}>
        <I18NProvider i18n={i18n}>
          <BaseComponent {...props} />
        </I18NProvider>
      </LocaleProvider>
    );
  };

  if (BaseComponent.fetchData) {
    WithI18NComponent.fetchData = BaseComponent.fetchData;
  }

  return WithI18NComponent;
};
